import styled from 'styled-components';
import imageBG from './bgconnect.png';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { InputFieldMainContainer,LabelContainer,InputContainer } from 'components/InputField/styles';
import { SIZE } from 'common/sizes';
import {RadioOptions, RadioOption } from "components/RadioButtonList/styles";

export const ConnectContainer = styled.div`
    display: flex;
    flex-flow: column;
    align-items: center;
    width:100%;
    background-image: url(${imageBG});
    background-repeat: no-repeat;
    background-size: cover;
`

export const ContainerTitle = styled.div`
    margin: ${SIZE.TWO}px 0;
    padding: ${SIZE.FOUR}px 0;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 34px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
    height: 100px;
    display: flex;
    align-items: center;
`

export const Box = styled.div`
    width: 670px;
    padding: 0 45px 35px 45px;
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
    background-color: #FFFFFF;
    margin-bottom: 0px;
    border: 1px solid #FFFFFF;
`

export const BoxTitle = styled.div`
    margin-top: ${SIZE.SIX}px;
    margin-bottom: ${SIZE.TWO}px;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
  height: 51px;
`

export const Indication = styled.div`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    margin-bottom: 40px;
`

export const InlineLeft = styled.div`
    display: flex;
    flex-direction: row;
    padding-top: ${SIZE.TWO}px;
    padding-bottom: ${SIZE.SIX}px;
    ${InputFieldMainContainer}{
        margin-left: 0px;
        padding-left: 0px;
    }
    ${LabelContainer}{
        margin-left: 0px;
        text-align: left;
    }
    ${InputContainer}{
        height: 48px;
        width: 288px;
        margin-left: 30px;
    }
`

export const InlineRight = styled.div`
    padding-top: ${SIZE.SIX}px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`

export const Field = styled.div`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
`

export const ErrorMsg = styled.span`
    margin-top: 25px;
    margin-bottom: 25px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    flex-grow: 0;
    background-image: linear-gradient(to top, #f36868, #f66000);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    width: 500px;
    white-space: pre-line;
    text-align: center;
`

export const ContainerBottom = styled.div`
    width: 100%;
    display: flex;
    flex: 1;
`

export const ImageBottomCotainer = styled.div`
    margin-left: 90px;
`

export const Icon = styled.span`
    display:flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 14px;
    position: relative;
    margin: ${SIZE.TEN}px 0;
`

export const Radio = styled.div`
    ${RadioOptions}{
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
    }
    ${RadioOption}{
        padding-bottom: ${SIZE.FOUR}px;
    }
`
